import { useTranslation } from 'react-i18next';
import type { IProductivitySummary } from '@apis/productivity';
import { Menu } from '@components/ui/Menu/Menu';
import { DownloadIcon } from '@utils/icons';
import csvIcon from '@assets/formats/csv.svg';
import pdfIcon from '@assets/formats/pdf.svg';
import excelIcon from '@assets/formats/excel.svg';
import styles from './ExportButton.module.css';

type ExportFormat = 'csv' | 'pdf' | 'excel';

interface IExportButtonProps {
  summary: IProductivitySummary | undefined; // while undefined the button is disabled.
}

const EXPORT_FORMATS: Array<{ format: ExportFormat; labelKey: string; icon: string }> = [
  { format: 'csv', labelKey: 'productivity.actions.exportCsv', icon: csvIcon },
  { format: 'pdf', labelKey: 'productivity.actions.exportPdf', icon: pdfIcon },
  { format: 'excel', labelKey: 'productivity.actions.exportExcel', icon: excelIcon },
];

export function ExportButton({ summary }: IExportButtonProps) {
  const { t } = useTranslation();

  return (
    <Menu.Root>
      <Menu.Trigger
        render={<button type="button" className={styles.button} disabled={!summary} />}
      >
        <DownloadIcon size={16} />
        {t('productivity.actions.export')}
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Positioner side="bottom" align="end" sideOffset={4}>
          <Menu.Popup className={styles.popup}>
            {EXPORT_FORMATS.map(({ format, labelKey, icon }) => (
              <Menu.Item key={format} className={styles.item} disabled>
                <img src={icon} alt="" className={styles.itemIcon} />
                {t(labelKey)}
                <span className={styles.soon}>{t('productivity.actions.exportComingSoon')}</span>
              </Menu.Item>
            ))}
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
}